import { RoomProvider } from '@/contexts/RoomContext'
import {
  PeerConnectionProvider,
  WebSocketProvider,
} from '@/contexts/connections'
import { ChannelProps, RootState } from '@/types'
import Sidebar from '@components/Sidebar'
import { connect } from 'react-redux'
import ConnectedRoomList from '../RoomList'
import Chat from './Chat'
import { UserGrid } from './UserGrid'

const Channel: React.FC<ChannelProps> = ({ selectedChannel, selectedRoom }) => {
  const url = `channels/${selectedChannel}/room/${selectedRoom}/messages`

  if (!selectedChannel || !selectedRoom) {
    return (
      <div className="flex h-full w-full">
        <Sidebar />
        {selectedChannel ? <ConnectedRoomList /> : null}
      </div>
    )
  }

  return (
    <WebSocketProvider url={url}>
      <PeerConnectionProvider>
        <div className="flex h-full w-full">
          <Sidebar />
          {selectedChannel ? <ConnectedRoomList /> : null}
          <RoomProvider>
            {selectedRoom && selectedChannel && <UserGrid />}
          </RoomProvider>
          {selectedRoom && selectedChannel && <Chat />}
        </div>
      </PeerConnectionProvider>
    </WebSocketProvider>
  )
}

const mapStateToProps = (state: RootState) => ({
  selectedChannel: state.channels.selectedChannelId,
  selectedRoom: state.rooms.selectedRoomId,
})

const connectedChannel = connect(mapStateToProps)(Channel)
export default connectedChannel
